// Circular progress bar and accordion handler components
import { isElementInView } from './helpers';

function progressBar(loaderObj, pct, r) {
  // eslint-disable-next-line

  return (function progressBarinner() {
    let val = parseInt(pct, 10);
    const circle = loaderObj.querySelector('.svg>.bar');
    if (isNaN(val)) { // eslint-disable-line
      val = 100;
    } else {
      // const r = circle.getAttribute('r');
      const c = 2 * Math.PI * r;

      if (val < 0) {
        val = 0;
      }

      if (val > 100) {
        val = 100;
      }

      const dashOffset = (100 - val) / 100 * c;
      circle.style.strokeDashoffset = dashOffset;
    }
  }());
}

const loaderContainers = document.querySelectorAll('.loader-container');

function animateLoader() {
  if (loaderContainers) {
    loaderContainers.forEach((loader) => {
      const percentage = loader.getAttribute('data-pct');
      if (isElementInView(loader)) {
        if (loader.querySelector('.svg>.bar')) {
          const radius = loader.querySelector('.svg>.bar').getAttribute('r');
          setTimeout(() => { progressBar(loader, percentage, radius); }, 500);
        }
      }
    });
  }
}

export default function accordionHandler() {
  const accordion = document.querySelectorAll('.js-accordion');
  if (accordion) {
    accordion.forEach((accordionEl) => {
      const accordionToggle = accordionEl.querySelectorAll('.js-accordion-toggle');
      accordionToggle.forEach((el) => {
        el.addEventListener('click', () => {
          const targetItem = el.parentElement;
          const targetParent = targetItem.parentElement;
          const targetContent = targetItem.querySelector('.js-accordion-content');
          const targetContentParent = targetContent.parentElement;
          const targetContentDesc = targetContentParent.parentElement;
          if (targetItem.classList.contains('open')) {
            targetItem.classList.remove('open');
            targetContent.style.maxHeight = null;
          } else {
            const accordionOpen = targetParent.querySelector('li.open');
            if (accordionOpen) {
              accordionOpen.classList.remove('open');
              accordionOpen.querySelector('.js-accordion-content').style.maxHeight = null;
            }
            targetItem.classList.add('open');
            targetContent.style.maxHeight = `${targetContent.scrollHeight}px`;
            if (targetContentDesc.classList.contains('js-accordion-content')) {
              targetContentDesc.style.maxHeight = '900px';
            }
          }
        });
      });
    });
  }
}

window.addEventListener('load', () => {
  accordionHandler();
  // adBubble();

  window.addEventListener('scroll', () => {
    animateLoader();
  });
});
